import React, { useEffect, useState } from "react";
import { FiUserCheck } from "react-icons/fi";
import { ApiEvent } from "./ApiEvent";
import { GetLanguageString } from "../helper/Components";
import "./ahbabManualCount.css";

// Read-only totals for the rufqa tab, in the same style as the ahbab total card.
const RufqaSummary = ({ eventId, refreshKey }) => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    ApiEvent()
      .getRufqaAttendanceSummary(eventId)
      .then((res) => setSummary(res.data))
      .catch((err) => console.log(err));
  }, [eventId, refreshKey]);

  if (!summary || summary.total === 0) {
    return null;
  }

  const presentShare = Math.round((summary.present / summary.total) * 100);

  return (
    <div className="amc-card">
      <div className="amc-head">
        <span className="amc-head-icon">
          <FiUserCheck />
        </span>
        <div className="amc-head-text">
          <div className="amc-title">
            <GetLanguageString props="events_rufqa_summary_title" />
          </div>
        </div>
      </div>
      <div className="amc-body">
        <div className="amc-tiles amc-tiles-4">
          <div className="amc-tile amc-tile-total">
            <b>{summary.total}</b>
            <span>
              <GetLanguageString props="events_ahbab_manual_count_total" />
            </span>
          </div>
          <div className="amc-tile amc-tile-marked">
            <b>{summary.present}</b>
            <span>
              <GetLanguageString props="events_participants_attendance_present" />
            </span>
          </div>
          <div className="amc-tile amc-tile-rest">
            <b>{summary.absent}</b>
            <span>
              <GetLanguageString props="events_participants_attendance_absent" />
            </span>
          </div>
          <div className="amc-tile amc-tile-leave">
            <b>{summary.leave}</b>
            <span>
              <GetLanguageString props="events_participants_attendance_leave" />
            </span>
          </div>
        </div>
        <div className="amc-bar" aria-hidden="true">
          <div className="amc-bar-fill" style={{ width: `${presentShare}%` }} />
        </div>
      </div>
    </div>
  );
};

export default RufqaSummary;
